var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lmnc-form-section-content",style:(_vm.contentOutsideSection)},_vm._l((_vm.numberOfRows),function(n){return _c('div',{key:n},[_vm._t(("row-" + n))],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }